import { useEffect, type ReactNode } from 'react'

export function PageMotion({ children }: { children: ReactNode }) {
	useEffect(() => {
		const reduced = window.matchMedia('(prefers-reduced-motion: reduce)').matches
		if (reduced) return

		let cancelled = false
		let cleanup = () => {}

		void (async () => {
			const [{ default: Lenis }, { gsap }, { ScrollTrigger }] = await Promise.all([
				import('lenis'),
				import('gsap'),
				import('gsap/ScrollTrigger'),
			])
			if (cancelled) return
			gsap.registerPlugin(ScrollTrigger)
			const lenis = new Lenis({ autoRaf: false })
			lenis.on('scroll', ScrollTrigger.update)
			const ticker = (time: number) => {
				lenis.raf(time * 1000)
			}
			gsap.ticker.add(ticker)
			gsap.ticker.lagSmoothing(0)
			cleanup = () => {
				gsap.ticker.remove(ticker)
				lenis.destroy()
				ScrollTrigger.getAll().forEach((t) => t.kill())
			}
		})()

		return () => {
			cancelled = true
			cleanup()
		}
	}, [])

	return children
}
